var indexOf = [].indexOf;

angular.module('shared').factory('DefaultReplyAddressService', ["$rootScope", function($rootScope) {
  var getDefaultEmail, gym;
  gym = $rootScope.gym;
  getDefaultEmail = function() {
    var defaultEmailAddress, item, ref;
    defaultEmailAddress = gym.gym_contact_detail.default_from_address;
    if (indexOf.call((function() {
      var i, len, ref, results;
      ref = gym.reply_email_addresses;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        results.push(item.email);
      }
      return results;
    })(), defaultEmailAddress) >= 0) {
      return defaultEmailAddress;
    } else {
      return (ref = gym.reply_email_addresses[0]) != null ? ref.email : void 0;
    }
  };
  return {
    getDefaultEmail: getDefaultEmail
  };
}]);
